var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { getCaseRolesFromUserRoleStrings, allCaseRoles } from "../../auth/CaseRoles";
import { paramsToSearchString } from "../../utils/urlHelper";
export class UsersService extends BaseRemoteService {
    getAll(params = {}) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/teams/${params.teamId}/users`;
            const data = yield _super.getRequest.call(this, url);
            return {
                totalCount: data.length,
                data: data
                    .sort((a, b) => (a.firstName > b.firstName ? 1 : -1))
                    .map(item => ({ id: item["upn"], name: item["fullName"] || item["upn"] })),
            };
        });
    }
    get(id) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/users/${id}`;
            const item = yield _super.getRequest.call(this, url);
            return Object.assign(Object.assign({}, item), { name: item["fullName"] || id });
        });
    }
    getCaseRoleUsers() {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const root = `${this.apiRoot}`;
            const rolesString = allCaseRoles.map(r => `Role=${r}`).join("&");
            let pageUrl = `/users?page=0&pageSize=25&${rolesString}`;
            const users = [];
            while (!!pageUrl) {
                const response = yield _super.getRequest.call(this, `${root}${pageUrl}`);
                pageUrl = response.nextPageLink;
                users.push(...response.data);
            }
            const roleBasedUsers = users.map(user => {
                const roles = getCaseRolesFromUserRoleStrings(user.userRoles);
                return Object.assign(Object.assign({}, user), { roles });
            });
            return roleBasedUsers;
        });
    }
    getUsers() {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/users/${paramsToSearchString({
                pageSize: 999,
                userType: 1,
                active: true,
            })}`;
            const response = yield _super.getRequest.call(this, url);
            return {
                data: response.data
                    .sort((a, b) => (a.upn > b.upn ? 1 : -1))
                    .map(item => ({ id: item["upn"], name: item["upn"] })),
            };
        });
    }
}
